import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Metrics from '@spotahome/soyuz-metrics';

const hasEventTracking = tracking =>
  Object.values(tracking).filter(eventType => eventType).length;

// TODO: Remove once all usages of <Checkbox> have been
// updated to use soyuz-metrics for tracking instead of the class
// implementation.
const getClassNameUsingTracking = tracking => `checkbox__input ${tracking}`;

class FormCheckBox extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    checked: PropTypes.bool,
    tracking: PropTypes.string,
    soyuzTracking: PropTypes.shape({
      eventCategory: PropTypes.string,
      eventAction: PropTypes.string,
      eventLabel: PropTypes.string,
      eventValue: PropTypes.string
    }),
    onChange: PropTypes.func.isRequired,
    cy: PropTypes.string
  };

  static defaultProps = {
    checked: false,
    tracking: null,
    soyuzTracking: {
      eventCategory: null,
      eventAction: null,
      eventLabel: null,
      eventValue: null
    },
    cy: null
  };

  state = {
    isChecked: !!this.props.checked
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.isChecked !== this.props.checked) {
      this.updateIsChecked();
    }
  }

  updateIsChecked() {
    const { checked } = this.props;

    this.setState({ isChecked: checked });
  }

  handleClick = () => {
    const { soyuzTracking, onChange } = this.props;

    this.setState(
      state => ({ isChecked: !state.isChecked }),
      () => onChange(this.state.isChecked)
    );

    if (!this.state.isChecked && hasEventTracking(soyuzTracking)) {
      this.trackEvent(soyuzTracking);
    }
  };

  trackEvent = (...eventTypes) => {
    Metrics.ga.sendEvent(...Object.values(...eventTypes));
  };

  render() {
    return (
      <div className="checkbox">
        <input
          className={getClassNameUsingTracking(this.props.tracking)}
          type="checkbox"
          id={this.props.id}
          data-cy={this.props.cy}
          onChange={this.handleClick}
          checked={this.state.isChecked}
        />
        <label className="checkbox__label" htmlFor={this.props.id}>
          {this.props.label}
        </label>
      </div>
    );
  }
}

export default FormCheckBox;
